<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="maintenanceStore.isMaintenanceMode" class="maintenance-overlay">
        <div class="maintenance-wrapper">
          <div class="card border-0 maintenance-card">
            <div class="card-header border-0 border-bottom pt-6 pb-4 px-6">
              <div class="card-title d-flex flex-column align-items-center w-100 mb-0">
                <img src="https://hub.affimedia.nl/media/logos/lca/lca_logo_2.png" alt="Logo" class="maintenance-logo mb-4" />
                <h1 class="maintenance-heading fw-bold fs-2 m-0 text-danger">Scheduled Maintenance</h1>
              </div>
            </div>
            <div class="card-body p-6">
              <div class="maintenance-notice rounded p-5">
                <p class="mb-2 fs-6 lh-lg text-body">
                  We apologise for the inconvenience.
                  {{ maintenanceStore.maintenanceMessage }}
                </p>
                <p class="mb-0 fs-6 lh-lg text-muted">Please try again shortly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { useMaintenanceModeStore } from "@/stores/maintenanceMode"

const maintenanceStore = useMaintenanceModeStore()
</script>

<style lang="scss" scoped>
.maintenance-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background-color: var(--bs-body-bg, #f5f8fa);
}

.maintenance-wrapper {
  width: 100%;
  max-width: 480px;
}

.maintenance-card {
  box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.05), 0 0.5rem 1rem rgba(0, 0, 0, 0.05);
}

.maintenance-logo {
  max-width: 200px;
  max-height: 90px;
  object-fit: contain;
  display: block;
}

.maintenance-heading {
  color: var(--bs-heading-color, #1e293b);
  letter-spacing: -0.01em;
}

.card-header.border-bottom {
  border-color: var(--bs-border-color, #e4e6ef) !important;
}

.maintenance-notice {
  background-color: var(--bs-light, #f9f9f9);
  border: 1px solid var(--bs-border-color-translucent, rgba(0, 0, 0, 0.08));
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
